import React from "react";
import "./Menubar.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

const Menubar = () => {
  return (
    <Navbar collapseOnSelect expand="lg " className="nav ">
      <Container>
        <Navbar.Brand>
          <h1 className="logo ">
            <span className="logo-main me-2">
            <span className="single me-2 fw-bold">J</span>
            JANNATUL FERDOUS 
            </span>
            HAPPY
          </h1>
        </Navbar.Brand>
        <Navbar.Toggle id="toggle" aria-controls="responsive-navbar-nav">
          <i className="fas fa-sliders-h"></i>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Link className="nav-item" to="/home">
              Home
            </Link>

            <Link className="nav-item" to="/aboutMe">
              ABOUT ME
            </Link>
            <Link className="nav-item" to="/projects">
              PROJECTS
            </Link>
            <Link className="nav-item" to="/blogs">
             BLOGS
            </Link>
            <Link className="nav-item" to="/contact">
              CONTACT ME
            </Link>
           
          </Nav>
         
        </Navbar.Collapse>
      </Container>
     
    </Navbar>
  );
};

export default Menubar;
